module.exports = __webpack_public_path__ + "img/D202312_1.69bc9a9c.jpg";